module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/favicon_travel.png?7ec037600448a85477a2848eff8f3c0a";